import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, checkBox, constantField, textBox } from "trader.ts/ui.forms";
import {
  instrumentid,
  internalteacherid,
  teacherid,
} from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { checkboxesField } from "../../client/checkboxesfield";
import { renderDeleteButton, renderSaveButton } from "../../client/savebutton";
import { emailValidation } from "../../lib/emailisvalid";
import * as routes from "../../routes";
import {
  mandatoryValidation,
  nameValidation,
  zipValidation,
} from "../../lib/validate";

export function render(opts: {
  teacher: null | {
    id: teacherid;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    comments: string;

    street: string;
    number: string;
    bus: string;
    zip: string;
    city: string;

    active: boolean;
    internalteacherid: internalteacherid;
    managesinvoices: boolean;
    instruments:
      | {
          id: instrumentid;
          description: string;
        }[]
      | null;
  };
  allInstruments: {
    id: instrumentid;
    description: string;
  }[];
  teachersCanManageInvoices: boolean;
}): HTMLElement | HTMLElement[] {
  const teacher = opts.teacher;
  const form = new Form({})
    .addField("id", [], () => constantField(teacher?.id ?? null))
    .addField("internalteacherid", [], () =>
      constantField(teacher?.internalteacherid ?? null),
    )
    .addField("firstname", [], () =>
      textBox({
        initialVal: teacher?.firstname || "",
        label: "Voornaam",
        validations: [mandatoryValidation, nameValidation],
      }),
    )
    .addField("lastname", [], () =>
      textBox({
        initialVal: teacher?.lastname || "",
        label: "Achternaam",
        validations: [mandatoryValidation, nameValidation],
      }),
    )
    .addField("email", [], () =>
      textBox({
        initialVal: teacher?.email || "",
        type: "email",
        label: "Email",
        validations: [emailValidation],
      }),
    )
    .addField("phone", [], () =>
      textBox({
        initialVal: teacher?.phone || "",
        label: "Telefoon",
      }),
    )
    .addField("street", [], () =>
      textBox({
        initialVal: teacher?.street || "",
        label: "Straatnaam",
      }),
    )
    .addField("number", [], () =>
      textBox({
        initialVal: teacher?.number || "",
        label: "Huisnummer",
      }),
    )
    .addField("bus", [], () =>
      textBox({
        initialVal: teacher?.bus || "",
        label: "Bus",
      }),
    )
    .addField("zip", [], () =>
      textBox({
        initialVal: teacher?.zip || "",
        label: "Postcode",
        validations: [zipValidation],
      }),
    )
    .addField("city", [], () =>
      textBox({
        initialVal: teacher?.city || "",
        label: "Woonplaats",
      }),
    )
    .addField("comments", [], () =>
      textBox({
        label: "Extra info",
        initialVal: teacher?.comments || "",
        type: "textarea",
      }),
    )
    .addField("instruments", [], async () =>
      checkboxesField({
        initial: opts.allInstruments.filter((instr) =>
          (teacher?.instruments || []).some((instr2) => instr.id === instr2.id),
        ),
        label: "Cursussen",
        values: opts.allInstruments.orderBy((instr) => instr.description),
        show: (t) => t.description,
        addNoFilterOption: false,
      }),
    )
    .addField("managesinvoices", [], () => {
      if (opts.teachersCanManageInvoices === true) {
        return checkBox({
          initialVal: teacher?.managesinvoices || false,
          label:
            "Beheert lesgeld zelf " +
            "(" +
            "Dit betekent dat we voor inschrijvingen bij deze docent geen facturen voor het lesgeld zullen aanmaken" +
            ")",
        });
      } else {
        return constantField(false);
      }
    })

    .build({
      render: (fields) => (
        <div className={style.equal_columns}>
          <div>
            {fields.firstname()}
            {fields.lastname()}
            {fields.email()}
            {fields.phone()}

            {fields.street()}
            <div className={style.equal_columns}>
              {fields.number()}
              {fields.bus()}
            </div>

            <div className={style.equal_columns}>
              {fields.zip()}
              {fields.city()}
            </div>

            {fields.comments()}
          </div>
          <div>{fields.instruments()}</div>
        </div>
      ),
    });

  return (
    <section>
      <section>{form.render()}</section>
      <div style="text-align: right">
        {teacher !== null ? (
          teacher.active ? (
            renderDeleteButton({
              label: "Deactiveer docent",
              panelStyle: "max-width: 400px;",
              confirmationLabel: "Wanneer je een docent deactiveert blijven inschrijvingen en lessen bestaan, maar kan je geen nieuwe lessenreeksen meer inplannen. Je kan deze docent steeds terug activeren.",
              doDelete: () =>
                rpc(routes.setTeacherActiveSpec, undefined, {
                  internalteacherid: teacher.internalteacherid,
                  active: false,
                }),
              redirectTo: routes.teacher_listRoute.link({
                include_external_and_deactivated: undefined,
              }),
            })
          ) : (
            renderSaveButton({
              save: () =>
                rpc(routes.setTeacherActiveSpec, undefined, {
                  internalteacherid: teacher.internalteacherid,
                  active: true,
                }),
              text: {
                normal: "Activeer docent",
                success: "Docent opnieuw geactiveerd!",
              },
              reload: true,
            })
          )
        ) : (
          <span></span>
        )}

        {!teacher || teacher.active === true ? (
          renderSaveButton({
            formS: form.s,
            save: (stu) =>
              rpc(routes.saveTeacherSpec, undefined, stu).then((res) => {
                if ("tag" in res && res.tag === "success") {
                  return {
                    tag: "success",
                    redirectUrl: routes.teacher_editRoute.link({
                      internalteacherid: res.internalteacherid,
                    }),
                    timeout: 1500,
                  };
                }
              }),
            reload: false,
          })
        ) : (
          <span></span>
        )}
      </div>
    </section>
  );
}
